module.exports = __webpack_public_path__ + "static/media/sms-icons.dd713ae5.svg";